'use client';

import { ReactNode, useState } from "react";
import InvestModalContext from "./context";

export default function InvestModalProvider({ children }: { children: ReactNode }) {

  const [isOpen, setIsOpen] = useState(false)

  return <InvestModalContext.Provider value={{
    isOpen: isOpen,
    setIsOpen: setIsOpen
  }}>
    {children}
  </InvestModalContext.Provider>
}